


































import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppActionButtons from '@/components/AppActionButtons.vue'
import AppCheckRound from '@/components/AppCheckRound.vue'
import AppRouterLink from '@/components/AppRouterLink.vue'

import { CURRENT_USER } from '@/gql/auth'
import { OrderMixin } from '@/mixins'
import { Order, OrderItem, OrderDelivery } from '@/interfaces'

@Component({
  components: {
    AppActionButtons,
    AppCheckRound,
    AppRouterLink
  },
  apollo: {
    currentUser: {
      query: CURRENT_USER
    }
  }
})
export default class extends Mixins(OrderMixin) {
  @Prop(Boolean) readonly disabled!: boolean
  @Prop(Boolean) readonly checkbox!: boolean
  @Prop() readonly order!: Order
  @Prop() readonly orderDelivery!: OrderDelivery
  @Prop() readonly orderItem!: OrderItem
  @Prop() readonly showActions!: boolean
  @Prop() readonly orderItemSelected!: { [key: string]: string }
  selectedReviewFile?: File
  currentUser = null

  get actions () {
    return this.deliveryIsDelayed(this.orderDelivery) ? ['SHOW_DELAY_INFO', ...this.orderItem.actions] : this.orderItem.actions
  }

  getOrderItemActionText (action: string) {
    switch (action) {
      case 'REQUEST_CANCELING': return '취소 요청'
      case 'REQUEST_RETURNING': return '반품 요청'
      case 'WITHDRAW_CANCELING': return '취소 철회'
      case 'WITHDRAW_RETURNING': return '반품 철회'
      case 'ASK_TO_SELLER': return this.currentUser ? '문의하기' : '전화문의'
      case 'REVIEW': return '스토리 남기기'
      case 'SHOW_DELAY_INFO':
        return '지연 정보'
      case 'BROWSE_DELIVERY_STATUS':
        return '배송 조회'
      case 'BROWSE_RETURNING': return '반품 정보'
      case 'BROWSE_CANCELING': return '취소 정보'
      case 'CONFIRM': return '구매확정'
      case 'CANCEL_PAYMENT': return '입금 취소'
      case 'PROCESS_PAYMENT': return '결제하기'
      case 'CANCEL_ORDER': return '주문 취소'
      case 'CREATE_REVIEW': return '리뷰 남기기'
      case 'UPDATE_REVIEW': return '리뷰 수정하기'
    }
    return ''
  }

  get orderItemStatusTitle () {
    return this.getTitleAndColor(this.order.status, this.orderDelivery.status, this.orderItem.status,
      this.deliveryIsDelayed(this.orderDelivery)).title
  }

  get orderItemStatusColorClass () {
    const color = this.getTitleAndColor(this.order.status, this.orderDelivery.status, this.orderItem.status,
      this.deliveryIsDelayed(this.orderDelivery)).color
    if (color === 'mainBlue') {
      return 'order-item__status--secondary'
    } else if (color === 'chili') {
      return 'order-item__status--primary'
    } else {
      return 'order-item__status--warm-grey'
    }
  }

  async actionClicked (action: string) {
    if (action === 'REQUEST_CANCELING') {
      await this.routerPush(`/orders/${this.order.id}/cancels/new?cancelType=REFUND&orderDeliveryId=${this.orderDelivery.id}&orderItemId=${this.orderItem.id}`)
    } else if (action === 'REQUEST_RETURNING') {
      await this.routerPush(`/orders/${this.order.id}/cancels/new?cancelType=RETURN&orderDeliveryId=${this.orderDelivery.id}&orderItemId=${this.orderItem.id}`)
    } else if (action === 'WITHDRAW_CANCELING') {
      this.$emit('action', {
        action,
        orderItemId: this.orderItem.id,
        cancelType: 'REFUND'
      })
    } else if (action === 'WITHDRAW_RETURNING') {
      this.$emit('action', {
        action,
        orderItemId: this.orderItem.id,
        cancelType: 'RETURN'
      })
    } else if (action === 'ASK_TO_SELLER') {
      if (this.currentUser) {
        await this.routerPush(`/items/${this.orderItem.item.id}/asks/new?orderId=${this.order.id}&orderItemId=${this.orderItem.id}`)
      } else {
        window.open(`tel:${this.orderDelivery.seller?.shop.phone}`, '_self')
      }
    } else if (action === 'REVIEW') {
      this.$emit('action', {
        action,
        orderItem: this.orderItem,
        seller: this.orderDelivery.seller,
        file: this.selectedReviewFile
      })
    } else if (action === 'SHOW_DELAY_INFO') {
      await this.routerPush(`/order-deliveries/${this.orderDelivery.id}/delay-info`)
    } else if (action === 'BROWSE_DELIVERY_STATUS') {
      await this.routerPush(`/order-deliveries/${this.orderDelivery.id}/tracking`)
    } else if (action === 'BROWSE_RETURNING' || action === 'BROWSE_CANCELING') {
      const orderCancellation = this.getOrderCancellationForOrderItem(this.order, this.orderItem)
      if (!orderCancellation) {
        return
      }
      await this.routerPush(`/orders/${this.order.id}/cancels?orderDeliveryId=${this.orderDelivery.id}&orderCancellationId=${orderCancellation.id}`)
      this.$emit('action', {
        action,
        orderCancellation,
        orderDelivery: this.orderDelivery
      })
    } else if (action === 'CONFIRM') {
      this.$emit('action', {
        action,
        orderItemId: this.orderItem.id
      })
    } else if (action === 'CANCEL_PAYMENT') {
      await this.routerPush(`/orders/${this.order.id}/payment-cancel`)
    } else if (action === 'PROCESS_PAYMENT') {
      this.routerPush(`/orders/${this.order.id}/created`)
    } else if (action === 'CANCEL_ORDER') {
      this.$emit('action', {
        action
      })
    } else if (action === 'CREATE_REVIEW') {
      this.routerPush(`/items/${this.orderItem.item.id}/reviews/${this.orderItem.id}/new`)
    } else if (action === 'UPDATE_REVIEW') {
      this.routerPush(`/items/${this.orderItem.item.id}/reviews/${this.orderItem.id}`)
    }
  }
}
